import de from './Texte_de-DE.json';
import en from './Texte_en-GB.json';
import es from './Texte_es-ES.json';
import fr from './Texte_fr-FR.json';
import it from './Texte_it-IT.json';
import pl from './Texte_pl-PL.json';
import ro from './Texte_ro-RO.json';
import ru from './Texte_ru-RU.json';
import tr from './Texte_tr-TR.json';
import uk from './Texte_uk-UA.json';
import ar from './Texte_ar.json';

export type CalcTexts = typeof de;

export function getTexts(lang?: string): CalcTexts {
  switch (lang) {
    case 'en': return en as CalcTexts;
    case 'es': return es as CalcTexts;
    case 'fr': return fr as CalcTexts;
    case 'it': return it as CalcTexts;
    case 'pl': return pl as CalcTexts;
    case 'ro': return ro as CalcTexts;
    case 'ru': return ru as CalcTexts;
    case 'tr': return tr as CalcTexts;
    case 'uk': return uk as CalcTexts;
    case 'ar': return ar as CalcTexts;
    default:   return de;
  }
}
